import React, { useEffect, useRef, useState } from "react";
import {
  JOB_DETAILS_HEADER,
  TERMSANDCONDITION_HEADER,
} from "../../../App.config";
import DropdownComponent from "../../../containers/Dropdown";
import validation from "../../../utilities/validation";
import * as utilities from "../../../utilities/utils";

const JobDetailModalComponent = (props) => {
  const initialState = {
    jobName: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
    },
    jobDesc: {
      value: "",
      error: "",
    },
    isSubmitOnce: { value: false },
  };

  const [state, setState] = useState(initialState);

  // Set to inital state after component change
  useEffect(() => {
    return () => {
      setState((state) => {
        return {
          ...initialState,
        };
      });
    };
  }, []);

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return {
        ...state,
        [name]: updatedObj,
      };
    });
  };

  const onDropDownChange = (event) => {
    let { name, value } = event;

    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const FormValidation = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let validatedObj = validation(state[property], props.context);

        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const isFormValid = () => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (state[property]?.error.length > 0) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  const onSubmit = () => {
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });

    FormValidation();

    if (isFormValid()) {
      let jobDetails = {
        jobName: state.jobName.value,
        jobDesc: state.jobDesc.value,
      };
      props.addNewJobTitle(jobDetails, props.locationID);
    } else {
      if (state.jobName?.ref?.current.focus) {
        state.jobName.ref.current.focus();
      }
    }
  };

  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {props.context.t(
              "STD-Employer-Statement.form.Employer-Details.label.heading.JobModalHeading"
            )}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => props.closeRemoveModal()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <span>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                  <label htmlFor="">
                    {props.context.t(
                      "STD-Employer-Statement.form.Employee-Details.label.text.Job"
                    )}
                    <span size="5" className="error-star">
                      *
                    </span>
                  </label>
                  <div className="form-group">
                    <input
                      placeholder={props.context.t(
                        "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      )}
                      className="form-control"
                      name="jobName"
                      ref={state.jobName.ref}
                      value={state.jobName.value}
                      onChange={handleChanges}
                    />
                    {state.jobName?.error && (
                      <span className="error">{state.jobName.error}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                  <label htmlFor="">
                    {props.context.t(
                      "STD-Employer-Statement.form.Employee-Details.label.text.Job-Desc"
                    )}
                  </label>
                  <div className="form-group">
                    <textarea
                      placeholder={props.context.t(
                        "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      )}
                      className="form-control"
                      name="jobDesc"
                      value={state.jobDesc.value}
                      onChange={handleChanges}
                    />
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>
        <div className="modal-footer">
          <button onClick={onSubmit} type="button" className="btn btn-primary">
            {props.context.t("STD-Employer-Statement.form.Common.Submit")}
          </button>
        </div>
      </div>
    </div>
  );
};
export default JobDetailModalComponent;
